import React, { Component } from 'react';
import Buttons from './components/Buttons';
import './App.css';
import '@fontsource/roboto/300.css';
import '@fontsource/roboto/400.css';
import '@fontsource/roboto/500.css';
import '@fontsource/roboto/700.css';

class App extends Component {
  render(){

    return (
    <div className="App">
     <Buttons />
    </div>
  );
}
}


export default App;
